import api from './api'

export interface UserPreferences {
  default_site_id: string | null
  default_site_name: string | null
  default_site_slug: string | null
}

export const preferencesApi = {
  get: () => api.get<UserPreferences>('/me/preferences').then((r) => r.data),
  update: (data: { default_site_id?: string | null }) =>
    api.patch<UserPreferences>('/me/preferences', data).then((r) => r.data),
}
